export const HEADINGS = [
  ["first_name", "First Name"],
  ["last_name", "Last Name"],
  ["position_title", "Position"],
  ["phone", "Phone Number"],
  ["mobile", "Mobile"],
  ["email", "Email Address"],
];
